import firebase from "firebase";
import FirebaseModel, { FirebaseModelData } from "./FirebaseModel";
import ProcessoModel from "./Processo";
import _debug from "debug";

const debug = _debug("Mediacao:models:Chst.ts");

export const CHAT_COLLECTION = "chatsProcesso";

export interface ChatDados extends FirebaseModelData {
    id?: string;
    data: firebase.firestore.Timestamp;
    status: string;
}

export default class ChatModel extends FirebaseModel {
    public get status() {
        return this.myData.status;
    }

    public set status(theNewStatus: string) {
        this.myData.status = theNewStatus;
    }

    public get id(): string | undefined {
        return this.myData.id;
    }
    public set id(id: string | undefined) {
        this.myData.id = id;
    }

    public get data(): Date {
        return this.myData.data.toDate();
    }
    public set data(date: Date) {
        this.myData.data = firebase.firestore.Timestamp.fromDate(date);
    }

    public get processo() {
        return this.myProcesso;
    }

    public static async fetchById(id: string, withPartes = false): Promise<ChatModel> {
        const query = firebase
            .firestore()
            .collectionGroup(CHAT_COLLECTION)
            .where("id", "==", id);

        const chats = await query.get();
        if (!chats.empty) {
            return this.fromQuerySnapshot(chats.docs[0]);
        } else {
            throw new Error(`Chat não econtrado!(id:${id})`);
        }
    }

    private static fromQuerySnapshot(doc: firebase.firestore.QueryDocumentSnapshot) {
        const dados: unknown = Object.assign({ id: doc.id }, doc.data());
        return new ChatModel(FirebaseModel.fromRef2String(dados) as ChatDados, doc.ref.parent.parent);
    }

    protected myData: ChatDados;
    protected myProcesso: ProcessoModel | null;

    constructor(dados?: ChatDados, processoRef: firebase.firestore.DocumentReference | null = null, processoModel: ProcessoModel | null = null) {
        super(CHAT_COLLECTION);
        if (!dados) {
            this.myData = {
                id: undefined,
                status: "aberto",
                data: firebase.firestore.Timestamp.now(),
            };
        } else {
            this.myData = dados;
        }
        this.myProcesso = null;
        if (processoModel) {
            this.myProcesso = processoModel;
        } else if (processoRef) {
            processoRef.get().then(processoDoc => {
                this.myProcesso = ProcessoModel.fromQuerySnapshot(processoDoc);
            });
        }
    }

    public async save() {
        const savedData = await super.update(this.myData);
        Object.assign(this.myData, savedData);
        return savedData;
    }
}
